import { Breadcrumb, Card, Container } from 'nhsuk-react-components';
import { Link } from 'react-router-dom';
import useUser from 'hooks/useUser';
import { getUrlForAdminCard } from 'utils/adminUtils';
import adminCards from 'utils/adminCards.ts';

function AdminPage() {
  const { roles } = useUser();

  return (
    <Container>
      <div className="nhsuk-u-margin-bottom-6">
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span aria-current="page">Admin home</span>
          </Breadcrumb.Item>
        </Breadcrumb>
      </div>
      <Card>
        <>
          <h1
            role="main"
            id="maincontent"
            className="nhsuk-heading-l nhsuk-u-margin-top-0 nhsuk-u-margin-bottom-3"
          >
            Admin home
          </h1>
          <p>
            Use this page to access SPI admin settings. Select an option below to continue.
          </p>
        </>
      </Card>
      <Card>
        <div className="nhsuk-grid-row">
          {adminCards
            .filter((card) => roles.some((role) => role.includes(card.requiredRole)))
            .map((card) => (
              <div key={card.id} className="nhsuk-grid-column-one-third">
                <Card>
                  <>
                    <h4 className="nhsuk-u-margin-bottom-3">
                      <Link
                        className="nhsuk-u-font-weight-bold nhsuk-u-margin-bottom-3"
                        to={getUrlForAdminCard(roles, card)}
                      >
                        {card.title}
                      </Link>
                    </h4>
                    <p>{card.description}</p>
                  </>
                </Card>
              </div>
            ))}
        </div>
      </Card>
    </Container>
  );
}

export default AdminPage;
